module.exports = __webpack_public_path__ + "img/horde.d8e430f8.png";